const NAMESPACE = 'MOBILE_APP_SELECTION' as const;

const BASE_URL = '/live/app-testing' as const;

const FETCH_FILES_PAGE_SIZE = 100 as const;

const FETCH_FILES_DEBOUNCE_THRESHOLD_MS = 300 as const;

export default {
  BASE_URL,
  FETCH_FILES_DEBOUNCE_THRESHOLD_MS,
  FETCH_FILES_PAGE_SIZE,
  NAMESPACE,
};
